import script from "./PaymentFailed.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentFailed.vue?vue&type=script&setup=true&lang=js"

import "./PaymentFailed.vue?vue&type=style&index=0&id=86d690d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d690d2"]])

export default __exports__